// extracted by mini-css-extract-plugin
module.exports = {"sponsor":"sponsor_sponsor__1PMEK","image":"sponsor_image__ZXoZd"};